export default __webpack_public_path__ + "static/18_36-adc9ca40563b754a5b5b5192e9db9afb.png";